import { featuresConfig, WidgetKey } from "config/features";

export const sorting = [
    featuresConfig.properties.key,
    featuresConfig.modelTree.key,
    featuresConfig.bookmarks.key,
    featuresConfig.selectionBasket.key,
    featuresConfig.groups.key,
    featuresConfig.search.key,
    featuresConfig.measure.key,
    featuresConfig.shareLink.key,
    featuresConfig.clippingPlanes.key,
    featuresConfig.orthoCam.key,
    featuresConfig.images.key,
    featuresConfig.propertyTree.key,
    featuresConfig.manhole.key,
    featuresConfig.area.key,
    featuresConfig.pointLine.key,
    featuresConfig.deviations.key,
    featuresConfig.followPath.key,
    featuresConfig.horizontalAlignment.key,
    featuresConfig.advancedSettings.key,
    featuresConfig.ditio.key,
] as WidgetKey[];
